export default function cardFilters() {

  // --------------------------------------------------------------------------
  // [Mobile only] Handle the click of the "show/hide all filters" button:
  // --------------------------------------------------------------------------
  const allFiltersTrigger = document.querySelector('.js-filter-meta__toggle')
  const allFiltersTarget  = document.querySelector('.js-content-sidebar__sidebar')

  if (!allFiltersTrigger || !allFiltersTarget) {
    return
  }

  allFiltersTrigger.onclick = () => {
    let expanded = allFiltersTrigger.getAttribute('aria-expanded') === 'true'
    allFiltersTrigger.setAttribute('aria-expanded', !expanded)
    allFiltersTarget.hidden = expanded
  }

  // When the layout is wide enough to be in its "two-column" mode, instantly
  // open all filter sections up:
  if (window.innerWidth >= 768) {
    allFiltersTrigger.click()
  }

  // --------------------------------------------------------------------------
  // Handle the click of each filter section's title:
  // --------------------------------------------------------------------------
  const cardFilterSectionTriggers = document.querySelectorAll('.js-card-filters h3')

  if (!cardFilterSectionTriggers) {
    return
  }

  Array.prototype.forEach.call(cardFilterSectionTriggers, (trigger, index) => {

    let btn = trigger.querySelector('button')
    let target = trigger.nextElementSibling

    btn.onclick = () => {
      let expanded = btn.getAttribute('aria-expanded') === 'true'
      btn.setAttribute('aria-expanded', !expanded)
      target.hidden = expanded
    }

    // When the layout is wide enough to be in its "two-column" mode, instantly
    // open the first filter section up:
    if (window.innerWidth >= 768 && index == 0) {
      btn.click()
    }

  })

}
